import axios from 'axios';

export const onboardingService = {
  async getStatus() {
    const { data } = await axios.get('/onboarding/status');
    return data;
  },

  async completeIntake(skipped = {}) {
    const { data } = await axios.post('/onboarding/complete', { skipped });
    return data;
  },

  async dismissChecklist() {
    const { data } = await axios.post('/onboarding/checklist/dismiss');
    return data;
  },

  async getSeedProducts() {
    const { data } = await axios.get('/onboarding/seed-products');
    return data.products || [];
  },

  async seedProducts(productIds) {
    const { data } = await axios.post('/onboarding/seed-products', {
      product_ids: productIds,
    });
    return data;
  },
};
